/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, createTourOperatorFromDiscriminatorValue, serializeTourOperator, serializeTourOperatorCreateRequest, serializeTourOperatorUpdateRequest, type ProblemDetails, type TourOperator, type TourOperatorCreateRequest, type TourOperatorUpdateRequest } from '../models/index.js';
// @ts-ignore
import { CurrentRequestBuilderRequestsMetadata, type CurrentRequestBuilder } from './current/index.js';
// @ts-ignore
import { TourOperatorItemRequestBuilderNavigationMetadata, TourOperatorItemRequestBuilderRequestsMetadata, type TourOperatorItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /TourOperator
 */
export interface TourOperatorRequestBuilder extends BaseRequestBuilder<TourOperatorRequestBuilder> {
    /**
     * The Current property
     */
    get current(): CurrentRequestBuilder;
    /**
     * Gets an item from the ApiSdk.TourOperator.item collection
     * @param id Unique identifier of the item
     * @returns {TourOperatorItemRequestBuilder}
     */
     byId(id: number) : TourOperatorItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<TourOperator[]>}
     */
     get(requestConfiguration?: RequestConfiguration<TourOperatorRequestBuilderGetQueryParameters> | undefined) : Promise<TourOperator[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<TourOperator>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     post(body: TourOperatorCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<TourOperator | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     put(body: TourOperatorUpdateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<TourOperatorRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: TourOperatorCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: TourOperatorUpdateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
export interface TourOperatorRequestBuilderGetQueryParameters {
    isActive?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const TourOperatorRequestBuilderUriTemplate = "{+baseurl}/TourOperator";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const TourOperatorRequestBuilderNavigationMetadata: Record<Exclude<keyof TourOperatorRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: TourOperatorItemRequestBuilderRequestsMetadata,
        navigationMetadata: TourOperatorItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["id"],
    },
    current: {
        requestsMetadata: CurrentRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const TourOperatorRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: "{+baseurl}/TourOperator?isActive={isActive}",
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createTourOperatorFromDiscriminatorValue,
    },
    post: {
        uriTemplate: TourOperatorRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createTourOperatorFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeTourOperatorCreateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    put: {
        uriTemplate: TourOperatorRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeTourOperatorUpdateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
